import { makeStyles, Theme } from '@material-ui/core/styles';

export const useFleetInputStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    marginBottom: 16,
    '& label.Mui-focused': { color: theme.palette.primary.main },
    // Uniform medium height everywhere (idem ClientApp2): dense inputs use the same 12px/14px padding.
    '& [class*="MuiOutlinedInput-input"]': { padding: '12px 14px' },
    '& [class*="MuiInputLabel-outlined"]:not([class*="MuiInputLabel-shrink"])': {
      top: 0,
      transform: 'translate(14px, 14px) scale(1)'
    },
    '& [class*="MuiInputLabel-outlined"][class*="MuiInputLabel-shrink"]': {
      top: '-3px',
      transform: 'translate(14px, -9px) scale(0.75)'
    },
    '& [class*="MuiOutlinedInput-root"]': { alignSelf: 'stretch', background: '#FFFFFF' },
    '& fieldset': { borderColor: theme.palette.grey[300] },
    '&:hover:not(:focus-within) fieldset': {
      borderColor: `${theme.palette.grey[300]} !important`
    },
    '&:focus-within fieldset': {
      borderColor: `${theme.palette.primary.main} !important`,
      borderWidth: 2
    },
    '& input, & textarea': {
      fontFamily: 'Montserrat',
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: '-0.28px',
      color: theme.palette.text.primary
    },
    // Input content height 1.4375em → field ~44.09px (idem ClientApp2 medium input).
    '& input': { height: '1.4375em' },
    '& [class*="Mui-disabled"] fieldset': {
      borderColor: `${theme.palette.action.disabled} !important`
    },
    '& input.Mui-disabled, & textarea.Mui-disabled': {
      color: theme.palette.text.disabled,
      WebkitTextFillColor: theme.palette.text.disabled
    }
  },
  error: {
    '& fieldset': { borderColor: `${theme.palette.error.main} !important` },
    '&:hover:not(:focus-within) fieldset': {
      borderColor: `${theme.palette.error.main} !important`
    },
    '&:focus-within fieldset': {
      borderColor: `${theme.palette.error.main} !important`,
      borderWidth: 2
    },
    '& label, & label.Mui-focused': { color: theme.palette.error.main }
  }
}));
